import React from "react";
import Pathfind from "./components/Pathfind"

const App = () =>{
    return (
        <div>
            <h1>
                <Pathfind />
            </h1>
        </div>
    );
};

export default App;
